import { associatedColours } from '../../../constants'
import { UNITS } from '../../../types/misc.types'
import { DistributionDatum } from '../../../types/mutual-fund-detail.types'
import { convertUnitAndValue } from '../../../utils/utils'

type DistributionVizPropTypes = {
  distributionData: DistributionDatum[]
}

const DISTRIBUTION_COLORS = [
  '#004D99',
  '#095EB2',
  '#1470CC',
  '#2E8AE5',
  '#4E9EED',
  '#6DB0F2',
  '#96C8FA',
  '#BFDFFF',
  '#E6F2FF'
]

const getDistributionColor = (idx: number) => {
  if (idx > DISTRIBUTION_COLORS?.length - 1) return '#E6F2FF'
  return DISTRIBUTION_COLORS?.[idx]
}

export default function DistributionViz({ distributionData }: DistributionVizPropTypes) {
  const getAssociatedColor = (category: DistributionDatum['category'], idx: number) => {
    const associatedColorObj = associatedColours?.[category]
    return associatedColorObj?.isColorInUse ? associatedColorObj?.color : getDistributionColor(idx)
  }

  return (
    <div className='flex flex-col gap-[16px] w-full'>
      <div className='rounded-[4px] flex gap-[2px] h-[16px] w-full overflow-hidden'>
        {distributionData?.map((datum, idx) => {
          if (datum?.weightage <= 0) return null

          // Calculate the total weightage to normalize
          const totalWeightage = distributionData.reduce((acc, currentDatum) => {
            return acc + (currentDatum?.weightage || 0)
          }, 0)

          // Normalize each weightage value based on the total weightage
          const normalizedWeightage = (datum?.weightage / totalWeightage) * 100

          return (
            <div
              key={idx.toString() + `${datum?.category}-color-bar`}
              style={{
                width: `${normalizedWeightage}%`,
                height: '100%',
                background: getAssociatedColor(datum?.category, idx) ?? 'whitesmoke'
              }}
            />
          )
        })}
      </div>
      <div className='flex flex-col gap-[8px]'>
        {distributionData?.map((datum, idx) => {
          return (
            <div key={idx.toString() + `${datum?.category}-map-colors`} className='flex justify-between'>
              <div className='flex items-center gap-[8px]'>
                <div
                  className='h-[6px] w-[6px] rounded-[50%] mt-[1px]'
                  style={{ background: getAssociatedColor(datum?.category, idx) ?? 'whitesmoke' }}
                ></div>
                <div className='text-[#6A6E6E]'>{associatedColours?.[datum?.category]?.label ?? datum?.category}</div>
              </div>
              <div className='font-[500] text-[13px]'>
                {convertUnitAndValue({
                  value: datum?.weightage,
                  unit: UNITS.PERCENTAGE
                })}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
